import { useAuth } from 'ply-auth'
import { createContext, useContext, useEffect, useState } from 'react'
import { WS } from '.'

const WebSocketContext = createContext<WS | null>(null)

WebSocketContext.displayName = 'WebSocketContext'

export const useWebSocket = () => useContext(WebSocketContext)

export function WebSocketProvider(props: any) {
	const [ws] = useState(() => new WS())
	const notifications = useAuth((state) =>
		state.user.loggedIn ? state.user.notifications : null,
	)

	useEffect(() => {
		if (notifications) {
			ws.url = notifications

			ws.connect()
		}

		return () => {
			ws.disconnect()
		}
	}, [notifications, ws])

	return <WebSocketContext.Provider {...props} value={ws} />
}

export const WebSocketConsumer = WebSocketContext.Consumer
